import React, {useEffect, useState} from 'react';
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import {setLanguage} from "../../actions/serverFunctions";
import Config, {AVAILABLE_LANGUAGES, POST_MESSAGES} from "../../config";
import {isIframe} from "../../misc/helpers";

const disallowClasses = [".language", ".language-list"];

const LanguageSwitcher = (props) => {

  const {language, setLanguage, intl, fabricatorSettings} = props;
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const handleWrapperBlur = (e) => {
    if (!disallowClasses.some(cls => e.target.closest(cls))) {
      setDropdownVisible(false)
    }
  };

  useEffect(() => {
    return () => {
      window.removeEventListener('click', handleWrapperBlur)
    }
  }, []);

  if (!fabricatorSettings.showLanguageSelect || (!Config.isDevMode() && !document.kvConfig.isBackend)) {
    return null
  }

  const activeLanguage = language;

  const handleButtonClick = () => {
    const newVisible = !dropdownVisible;
    setDropdownVisible(newVisible);
    setTimeout(() => {
      newVisible
        ? window.addEventListener('click', handleWrapperBlur)
        : window.removeEventListener('click', handleWrapperBlur)
    }, 0)
  };

  const handleLocaleClick = (locale) => {
    setLanguage(locale);
    if (isIframe() && window.parent) {
      window.parent.postMessage({
        action: POST_MESSAGES.setIframeLanguage,
        payload: { language: locale }
      }, "*");
    }
    handleButtonClick();
  };

  const getLanguageName = (locale) => {
    switch (locale) {
      case "en-US":
        return intl.formatMessage({id: "languageDropdown.english"})
      case "en-AU":
        return intl.formatMessage({id: "languageDropdown.australian"})
      case "fr-FR":
        return intl.formatMessage({id: "languageDropdown.french"})
      case "pl-PL":
        return intl.formatMessage({id: "languageDropdown.polish"})
      case "es-ES":
        return intl.formatMessage({id: "languageDropdown.spanish"})
      default:
        return locale
    }
  };

  const styles = {
    height: dropdownVisible ? AVAILABLE_LANGUAGES.length * 50 : 0
  }

  return (
    <div className="language">
      <button className={"materials-button materials-button--language" + (dropdownVisible ? " materials-button--active" : "")}
              onClick={handleButtonClick}>
        <span className="materials-button__text"><FormattedMessage id="header.languageButton"/></span>
      </button>
      <div className={"language-dropdown" + (dropdownVisible ? " language-dropdown--visible" : "")} style={styles}>
        <div className="language-dropdown__list">
          {AVAILABLE_LANGUAGES.map((locale, languageIndex) => (
            <li className={"language-dropdown__list-item" + (activeLanguage === locale ? " language-dropdown__list-item--active" : "")}
                key={languageIndex}
                onClick={() => handleLocaleClick(locale)}>
              {getLanguageName(locale)}
            </li>
          ))}
        </div>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  return {
    language: store.serverState.language,
    fabricatorSettings: store.fabricatorState.settings
  };
};

const mapDispatchToProps = {
  setLanguage,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LanguageSwitcher)
);
